import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams } from "react-router-dom";
import successToast from "../../components/toasts/successToast";
import { useDispatch } from "react-redux";
import errorToast from "../../components/toasts/errorToast";
import { Spinner } from "react-bootstrap";
import { addfolderAction, folderEdit, folderView } from "../../redux/actions/folderAction";
import { IoArrowBack } from "react-icons/io5";

const AddFolder = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [folderData, setFolderData] = useState({});
    const currentPath = window.location.pathname;
    const segments = currentPath.split("/");
    const pathSegment = segments[1];
    const { id } = useParams();
    const [disable, setDisable] = useState(false);

    const onViewSuccess = (data) => {
        setFolderData(data.data.data);
        setLoading(false);
    };

    const onViewError = (data) => {
        errorToast(data.data.message);
        setLoading(false);
    };

    useEffect(() => {
        if (id) {
            setLoading(true);
            dispatch(folderView({ id }, onViewSuccess, onViewError));
        }
    }, [id, dispatch]);

    const initialValues = {
        id: folderData?.id || "",
        name: folderData?.name || "",
    };

    const validationSchema = Yup.object().shape({
        name: Yup.string().required("Required"),
    });

    const onSubmit = (values) => {
        if (pathSegment === "edit-folder") {
            dispatch(folderEdit(values, onSuccess, onError));
        } else {
            dispatch(addfolderAction(values, onSuccess, onError));
        }
    };

    const onError = (data) => {
        errorToast(data?.data?.message);
    };

    const onSuccess = (data) => {
        successToast(data?.data?.message);
        navigate("/folders");
    };

    const pathLabels = {
        "edit-folder": "Edit Folder",
        "add-folder": "Add Folder",
    };

    return (
        <div className="d-flex vh-100">
            <div className="w-100 ">
                <div className="w-100 d-flex align-items-center header border-bottom position-sticky top-0 bg-white py-2">
                    <span className="px-1 fs_16 cursor_pointer pb-1" onClick={() => navigate(-1)}><IoArrowBack /></span>
                    <h2 className="fs_20 fw_400 fn_Roboto text-start px-3 pt-1">
                        {pathLabels[pathSegment]}
                    </h2>
                </div>
                <div className="flex-grow-1 pt-3">
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={onSubmit}
                        enableReinitialize
                    >
                        {({ values, setFieldValue, isValid, dirty }) => (
                            <Form className="d-flex flex-column h-100 justify-content-between">
                                <div>
                                    <div className="text-start gap-3 mb-2 text-nowrap mx-4">
                                        <label htmlFor="name" className="py-1">
                                            Folder Name
                                        </label>
                                        <div className="d-flex position-relative">
                                            <Field
                                                type="text"
                                                placeholder="Enter Folder Name"
                                                id="name"
                                                name="name"
                                                className="input-field"
                                                disabled={disable}
                                                style={{ width: "20rem" }}
                                            />
                                        </div>
                                        <ErrorMessage
                                            name="name"
                                            component="div"
                                            className="text-danger mt-1 fs_12"
                                        />
                                    </div>
                                </div>
                                {loading && (
                                    <div className="d-flex align-items-center text-center">
                                        <Spinner size="sm" className="text-primary" />{" "}
                                        <span className="ms-2">Updating...</span>
                                    </div>
                                )}
                                {!disable && (
                                    <div className="d-flex gap-5 mt-5 mx-4 my-3">
                                        <button
                                            type="submit"
                                            className="btn btn-primary"
                                            style={{ width: "5rem" }}
                                            disabled={!(isValid && dirty)}
                                        >
                                            {pathSegment === "edit-folder" ? "Update" : "Create"}
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-secondary"
                                            style={{ width: "5rem" }}
                                            onClick={() => navigate("/folders")}
                                        >
                                            Cancel
                                        </button>
                                    </div>
                                )}
                            </Form>
                        )}
                    </Formik>
                </div>
            </div>
        </div>
    );
};

export default AddFolder;
